import {Controller} from "@hotwired/stimulus";
import JustValidate from "just-validate";

export default class extends Controller {
    connect() {
        this.validator = new JustValidate(this.element, {
            validateBeforeSubmitting: true,
            errorFieldCssClass: "is-invalid",
        });
        
        this.validator
            .addField('[name="first_name"]', [
                {rule: "required", errorMessage: "First name is required"},
                {rule: "minLength", value: 2}
            ])
            .addField('[name="last_name"]', [
                {rule: "required", errorMessage: "Last name is required"},
                {rule: "minLength", value: 2}
            ])
            .addField('[name="card_number"]', [
                {rule: "required", errorMessage: "Card number is required"},
                {
                    validator: (value) => /^\d{12,19}$/.test(value.replace(/\s+/g, "")),
                    errorMessage: "Enter a valid card number"
                }
            ])
            .onSuccess(() => {
                alert("Form is valid!");
            });

        this.toggleGiftFields();
    }

    toggleGiftFields() {
        const yes = this.element.querySelector("#giftYes").checked;
        const no = this.element.querySelector("#giftNo").checked;

        if (yes && no) {
            this.element.querySelector("#giftNo").checked = false;
        }

        if (yes) {
            this.validator.showErrors({});
        } else {
            this.validator.refresh();
        }
    }
}